export const wooyeonGreen = '#1ec677ff'
export const wooyeonGrey2 = '#acacacff'
export const wooyeonLightGreen = '#FBFFFEff'
export const lottieGrey = '#fafafaff'
export const lottieGrey2 = '#f3f6f8ff'
export const wooyeonDarkGrey = '#434343ff'
export const wooyeonDarkGrey2 = '#706969ff'
